module.exports = __webpack_public_path__ + "static/banner-mobile-06fa19b5774c901ed32bbe1595a328d9.png";